<template>
  <Loader
    v-if="isLoading"
    class="pb-3"
  />
  <div
    v-else
    class="d-flex flex-column"
  >
    <MultiSelectComponent
      id="GroupConfigTermSelect"
      v-model="currentArray"
      class="mb-2 my-1 w-100"
      :max-selected-options="1"
      :label="trans('subscription.classification_config.group_modal.term')"
      :type="'term'"
      track-by="name"
      :query-options="{ 'programId': programId, 'withYear': 1 }"
      @input="changeSelectedValues"
    >
      <template
        slot="customTag"
        slot-scope="{ props }"
      >
        <div class="multiselect__tags-wrap">
          <span class="multiselect__tag">
            <span>{{ trans('core.term') }} {{ props.option.name }}</span>
            <i
              aria-hidden="true"
              tabindex="1"
              class="multiselect__tag-icon"
              @click="props.deleteValue(props.option)"
            />
          </span>
        </div>
      </template>
      <template
        slot="customOption"
        slot-scope="{ props }"
      >
        <label>
          {{ trans('core.term') }} {{ props.option.name }}
        </label>
      </template>
    </MultiSelectComponent>
  </div>
</template>

<script>
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import { mapState } from 'vuex'
export default {
  name: 'GroupConfigTermSelect',
  components: { MultiSelectComponent },
  inject: ['programId'],
  props: {
    term: {
      required: false,
      type: Number,
      default: undefined,
    },
  },
  data () {
    return {
      isLoading: true,
      currentArray: [],
    }
  },
  computed: {
    ...mapState({
      missingId (state) {
        if (!state.terms.terms.hasOwnProperty(this.term)) {
          return this.term
        }
        return null
      },
      terms (state) {
        if (!state.terms.terms.hasOwnProperty(this.term)) {
          return []
        }
        const result = state.terms.terms[this.term]
        return [{
          id: this.term,
          name: `${result.name} - ${result.year}`,
        }]
      },
    }),
  },
  watch: {
    term: {
      handler (newValue) {
        //* This mechanism is build, because it is not clear when you can get the relevant term
        if (newValue) {
          this.isLoading = true
          this.getTerm(newValue)
        }
        this.isLoading = false
      },
    },
  },
  mounted () {
    //* This mechanism is build, because it is not clear when you can get the relevant term
    this.isLoading = true
    this.getTerm(this.term)
    this.isLoading = false
  },
  methods: {
    changeSelectedValues (newValue) {
      const newValueArray = newValue.map(row => row.id)
      if (this.term) {
        if (this.arraysNotEqual([this.term], newValueArray)) {
          this.setValue(newValueArray)
        }
      } else {
        this.setValue(newValueArray)
      }
    },
    setValue (newValueArray) {
      if (newValueArray.length > 0) {
        this.selectorPropertyValueAdd(newValueArray[0])
      } else {
        this.selectorPropertyValueAdd(undefined)
      }
    },
    arraysNotEqual (array1, array2) {
      return array1.sort().join(',') !== array2.sort().join(',')
    },
    selectorPropertyValueAdd (newValue) {
      this.$emit('input', newValue)
    },
    getTerm (newValue) {
      if (newValue && this.missingId) {
        this.$store.dispatch('getTerms', {
          queryParams: {
            filter: {
              id: this.missingId,
              programId: this.programId,
            },
          },
        }).then(() => { this.currentArray = this.terms })
      }
      this.currentArray = this.terms
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/
.col-sm-2 {
  float: none;
  width: 100%;
}
/deep/
.col-sm-10 {
  float: none;
}
/deep/
.multi-select {
  width: 100%;
  padding: 0px;
}
/deep/
.control-label{
  padding: 0px;
}
</style>
